import axios from "axios";
import { removeAccessToken, setAccessToken } from "./tokenUtils";
import { _getConfig, getBaseUrl, getLsValues } from "./commonFunctions_v2";

export const refreshAccessToken = async () => {
    try {
        const response = await axios.get(`${getBaseUrl("ums")}/api/v1/auth/refresh-token`, {
            headers: {
                authorization: !!getLsValues() && !!getLsValues().refresh_token ? "Bearer " + getLsValues().refresh_token.toString() : "",
            },
            // withCredentials: true
        });
        if (response?.data && response?.data?.access_token) {
            // removeAccessToken();
            setAccessToken(response?.data?.access_token);
            return response?.data?.access_token;
        }
        throw new Error("No access token in refresh response");
    } catch (error) {
        throw error;
    }
};
